import { useQuery } from 'react-query'
import { axios } from '../../../lib'

export const loadSellers = (query: any): Promise<any> => {
  return axios.get('/users/sellers', {
    params: {
      ...query
    }
  })
}

export function useLoadSellers(query: any) {
  return useQuery(['sellers', query], () => loadSellers(query))
}
